import { Component, ElementRef, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { SfAnalyticsService } from '../../services/sf-analytics.service';
import { LogService } from '../../services/log.service';
import { Router } from '@angular/router';
import { LossReportService } from '../../services/loss-report.service';
import { RepairEligibilityService } from '../../services/repair.eligibility.service';
import { MediaUploadService } from '../../services/media-upload.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { CliffLogCodes } from '../../shared/constants/cliff-log-constants';

@Component({
  selector: 'olr-claim-already-submitted',
  templateUrl: './claim-already-submitted.component.html',
  styleUrls: ['./claim-already-submitted.component.css'],
  imports: [LottieComponent],
})
export class ClaimAlreadySubmittedComponent implements OnInit, OnDestroy, AfterViewInit {
  isClaimantLossReport = false;
  isInsuredAutoLossReport = false;
  loadingText = "Submitting your claim...";
  lossReportUpdateOneTime = false;
  startTime: number ;
  endTime: number;
  totalDuration: number;

  options: AnimationOptions = {
    path: 'assets/animations/animation.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

  constructor(
    @Inject('Window') private window: any,
    private analytics: SfAnalyticsService,
    private logService: LogService,
    public router: Router,
    private repairEligibilityService: RepairEligibilityService,
    private mediaUploadService: MediaUploadService,
  ) { }

  ngOnInit(): void {
    this.startTime = performance.now();
    const flowName = this.logService.getFlowName();
    this.isClaimantLossReport = flowName === 'filealoss-claimant' || flowName === 'filealoss-oic';
    this.isInsuredAutoLossReport = flowName === 'filealoss-auto';
    this.analytics.sendData(this.isInsuredAutoLossReport ? 'confirmation-please-wait' : 'claim-already-submitted');
  }

  ngAfterViewInit(): void {
    this.repairEligibilityService.evaluationBegin.subscribe(() => {
      this.loadingText = "Determining your next steps..."; 
    });
    this.mediaUploadService.mediaUploadStarted.subscribe(() => {
      this.loadingText = "Uploading your photos...";
    });
    this.mediaUploadService.mediaUploadComplete.subscribe(() => {
      this.router.navigate(['/confirmation/received-auto-claim']);
      this.endTime= performance.now();
    this.totalDuration = (this.endTime - this.startTime)/1000;
    this.logService.log(CliffLogCodes.CLAIM_SUBMISSINON_DURATION,{
      claimTotalSubmissionDuration: this.totalDuration
    });
    });
}

  ngOnDestroy(): void {
    this.repairEligibilityService.decisionReceived.unsubscribe();
    this.mediaUploadService.mediaUploadComplete.unsubscribe();
    this.mediaUploadService.mediaUploadStarted.unsubscribe();
  }
}
